import React from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_URL } from '../../../config';

const CtaBand = ({
  title = 'Ready to put CoPlaid to work?',
  sub = 'Tell us about your operation and we’ll point you at the right partner.',
  primary = { label: 'Talk to us', to: '/contact' },
  secondary = { label: 'Talk to us', to: '/contact' },
}) => {
  const navigate = useNavigate();
  const go = (target) => {
    if (!target) return;
    if (target === 'login') { window.location.href = `${APP_URL}/login`; return; }
    navigate(target);
  };
  return (
    <div className="cp-cta-band">
      <h3 className="cp-cta-band__title">{title}</h3>
      <p className="cp-cta-band__sub">{sub}</p>
      <div className="cp-cta-band__actions">
        {primary && (
          <button className="cp-btn cp-btn--primary cp-btn--lg" onClick={() => go(primary.to)}>{primary.label}</button>
        )}
        {secondary && (
          <button className="cp-btn cp-btn--ghost cp-btn--lg" onClick={() => go(secondary.to)}>{secondary.label}</button>
        )}
      </div>
    </div>
  );
};

export default CtaBand;
